import { computed, getCurrentInstance, watch } from "@vue/composition-api";

export default function useOnChangePage(cb: () => void) {
  const vm = getCurrentInstance();
  watch(
    computed(() => vm?.$route.fullPath),
    (path, old) => {
      if (path !== old) {
        cb();
      }
    }
  );
}
